import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'components/Spinner';

import { Container, CheckBoxWrapper, CheckBox, CheckBoxLabel } from './styles';

interface SwitchProps {
  disabled: boolean;
  id: number;
  checked: boolean;
  onChange: any;
  loading: boolean;
  align?: 'center' | 'flex-end' | 'flex-start';
}

export default function Switch({
  disabled = false,
  id = 0,
  checked = false,
  onChange,
  loading = false,
  align = 'center',
}: SwitchProps) {
  return (
    <Container>
      <CheckBoxWrapper>
        {loading ? (
          <Spinner align={align} type="ThreeDots" height={38} width={38} />
        ) : (
          <>
            <CheckBox
              id={`checkbox${id}`}
              type="checkbox"
              checked={checked}
              disabled={disabled}
              onChange={onChange}
            />
            <CheckBoxLabel htmlFor={`checkbox${id}`} />
          </>
        )}
      </CheckBoxWrapper>
    </Container>
  );
}

Switch.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.number.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  align: PropTypes.oneOf(['center', 'flex-end', 'flex-start']),
};
